import { render, staticRenderFns } from "./design-edit-form.vue?vue&type=template&id=5d62f726"
import script from "./design-edit-form.vue?vue&type=script&setup=true&lang=js"
export * from "./design-edit-form.vue?vue&type=script&setup=true&lang=js"
import style0 from "./design-edit-form.vue?vue&type=style&index=0&id=5d62f726&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports